export default __webpack_public_path__ + "static/media/logo-repubblica-bianca.4ddfb0c4.png";